import React from 'react';

type Props = {
  height?: number | string;
};
function EmptyState({ height = 200 }: Readonly<Props>) {
  return (
    <div
      className="m-auto w-100 text-lighter flex-column flex-grow flex items-center justify-center bg-lightest"
      style={{ height }}
    >
      <div>No data to display with selected options.</div>
      <div>Change filters or set different time frame</div>
    </div>
  );
}

export { EmptyState };
